import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
import { AudioPlayerContainerProptypes } from '../../../components/AudioPlayer/types/propsTypes';

const transformAudioPlayer = (props: CMSTransformerDataType): AudioPlayerContainerProptypes => {
  const audioPlayerTransformerProps = Array.isArray(props) ? props[0] : props;

  const payload: AudioPlayerContainerProptypes = {
    componentType: ComponentType.audio_player,
    audioFile: audioPlayerTransformerProps ?? {},
  };

  return payload;
};
export default transformAudioPlayer;
